import PropTypes from 'prop-types';
import * as R from 'ramda';
import React from 'react';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

import ErrorBoundary from '../../submodules/shared/components/error-boundary/error-boundary';

import AdminTab from './tabs/admin-tab';
import FilteredTab from './tabs/filtered-tab';
import LabTab from './tabs/lab-tab';

class Home extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            key: 'labs',
        };

        this.handleSelect = R.bind(this.handleSelect, this);
        this.renderTab = R.bind(this.renderTab, this);
    }

    handleSelect(key) {
        this.setState({ key });
    }

    // react-bootstrap <Tabs> reads eventKey/title off its direct <Tab> children,
    // so the boundary cannot be a wrapper component around <Tab>. This helper
    // returns the <Tab> element inline, centralizing the repeated
    // Tab > ErrorBoundary(reset key + name) shell.
    renderTab(eventKey, title, child) {
        return (
            <Tab eventKey={eventKey} title={title}>
                <ErrorBoundary key={`${eventKey}:${this.state.key}`} name={`home:${eventKey}-tab`}>
                    {child}
                </ErrorBoundary>
            </Tab>
        );
    }

    render() {
        const {
            appReducer,
            adminReducer,
            studentReducer,
            eventReducer,
            setProductAccess,
            fetchAccountAccess,
            fetchProductList,
            setAccountAccess,
            createAccountAccess,
            fetchStudentLabs,
            fetchEventLabs,
            setStudentId,
            setEventId,
            findLabsByProduct,
            findUserLabs,
            findFilteredStudentLabs,
            fetchUserCache,
            expireUserCache,
        } = this.props;

        return (
            <div className="home">
                {R.pathOr(false, ['appAccess', 'read'], appReducer) ? (
                    <Tabs activeKey={this.state.key} onSelect={this.handleSelect} id="controlled-tab-example">
                        {this.renderTab(
                            'labs',
                            'Labs',
                            <LabTab
                                {...R.pick(
                                    [
                                        'appReducer',
                                        'labReducer',
                                        'eventReducer',
                                        'fetchProducts',
                                        'fetchLabItems',
                                        'clearLabDetails',
                                    ],
                                    this.props,
                                )}
                            />,
                        )}
                        {this.renderTab(
                            'events',
                            'Events',
                            <FilteredTab
                                name="Event"
                                appReducer={appReducer}
                                reducer={eventReducer}
                                fetchProducts={fetchEventLabs}
                                setId={setEventId}
                                productLabs={eventReducer.productLabs}
                                fetchLabs={findLabsByProduct}
                            />,
                        )}
                        {this.renderTab(
                            'students',
                            'Students',
                            <FilteredTab
                                name="Student"
                                appReducer={appReducer}
                                reducer={studentReducer}
                                fetchProducts={fetchStudentLabs}
                                setId={setStudentId}
                                productLabs={studentReducer.productLabs}
                                fetchLabs={findFilteredStudentLabs}
                                findUserLabs={findUserLabs}
                            />,
                        )}
                        {R.pathOr(false, ['appAccess', 'admin'], appReducer)
                            ? this.renderTab(
                                  'admin',
                                  'Admin',
                                  <AdminTab
                                      adminReducer={adminReducer}
                                      setProductAccess={setProductAccess}
                                      fetchAccountAccess={fetchAccountAccess}
                                      fetchProductList={fetchProductList}
                                      setAccountAccess={setAccountAccess}
                                      createAccountAccess={createAccountAccess}
                                      fetchUserCache={fetchUserCache}
                                      expireUserCache={expireUserCache}
                                  />,
                              )
                            : null}
                    </Tabs>
                ) : null}
            </div>
        );
    }
}

Home.propTypes = {
    appReducer: PropTypes.object,
    adminReducer: PropTypes.object,
    labReducer: PropTypes.object,
    eventReducer: PropTypes.object,
    studentReducer: PropTypes.object,
    fetchProductList: PropTypes.func,
    setProductAccess: PropTypes.func,
    fetchAccountAccess: PropTypes.func,
    setAccountAccess: PropTypes.func,
    createAccountAccess: PropTypes.func,
    fetchProducts: PropTypes.func,
    fetchLabItems: PropTypes.func,
    fetchEventLabs: PropTypes.func,
    setEventId: PropTypes.func,
    setStudentId: PropTypes.func,
    fetchStudentLabs: PropTypes.func,
    findLabsByProduct: PropTypes.func,
    findUserLabs: PropTypes.func,
    fetchUserCache: PropTypes.func,
    expireUserCache: PropTypes.func,
    findFilteredStudentLabs: PropTypes.func,
    clearLabDetails: PropTypes.func,
};

export default Home;
